import { render } from "./GarageFitting.vue?vue&type=template&id=9d9ebf64"
import script from "./GarageFitting.vue?vue&type=script&lang=js"
export * from "./GarageFitting.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__